import {
  DASHBOARD_USERS,
  DASHBOARD_USERSCOUNT,
  DASHBOARD_DEVICE,
  DASHBOARD_OUTREACH,
  DASHBOARD_NETWORKING,
  DASHBOARD_SESSIONS,
  DASHBOARD_ITEM_SELECTED,
  DASHBOARD_ATTENDEES,
  DASHBOARD_ATTENADOPRATE,
  DASHBOARD_ATTEDENGARATE,
  DASHBOARD_INTERACTION,
  DASHBOARD_MESSAGESS,
  DASHBOARD_MOSTSEARCH_KEYWORDS,
  DASHBOARD_ENGAGEMENT_BARCHART,
  APPUSER_NOT_LOGIN_USERSCOUNT,
} from "DashboardActions";

export var DashBoardMenu = (state = [], action) => {
  var state = [
    {
      key: DASHBOARD_USERSCOUNT,
      iconName: "person",
      sectionName: "Users",
      sectionDesc: "Total no. of users",
      selected: false,
    },
    {
      key: DASHBOARD_USERS,
      iconName: "person",
      sectionName: "User Hits",
      sectionDesc: "Total no. of user hits on overiew screen",
      selected: false,
    },
    {
      key: DASHBOARD_DEVICE,
      iconName: "device",
      sectionName: "Device Installs",
      sectionDesc: "Device platform details for App installed and loggedin",
      selected: false,
    } /*,
    {
      key: DASHBOARD_OUTREACH,
      iconName: 'eye',
      sectionName: 'Outreach',
      selected: false
    }*/,
    {
      key: DASHBOARD_NETWORKING,
      iconName: "link",
      sectionName: "Networking",
      sectionDesc: "User engagement details for connection making",
      selected: false,
    },
    {
      key: DASHBOARD_SESSIONS,
      iconName: "timer",
      sectionName: "Sessions",
      sectionDesc: "Total no. of hiits on session screens",
      selected: false,
    },
    {
      key: DASHBOARD_ATTENDEES,
      iconName: "attendees",
      sectionName: "Attendees",
      sectionDesc: "Users who login to the app atleast ones",
      selected: false,
    },
    {
      key: DASHBOARD_ATTENADOPRATE,
      iconName: "attenadoprate",
      sectionName: "Attendees Adoption rate",
      sectionDesc: "Users who actually checked in the event",
      selected: false,
    },
    {
      key: DASHBOARD_ATTEDENGARATE,
      iconName: "attedengarate",
      sectionName: "Attendees Engagement rate",
      sectionDesc:
        "Attendees who were engaged in the app from overall attendees",
      selected: false,
    },
    {
      key: DASHBOARD_INTERACTION,
      iconName: "atninteraction",
      sectionName: "Interaction rate",
      sectionDesc: "Number of all actions user did on the app",
      selected: false,
    },
    {
      key: DASHBOARD_MESSAGESS,
      iconName: "messagess",
      sectionName: "Messages count",
      sectionDesc: "Total number of messages sent on the app",
      selected: false,
    },
    {
      key: APPUSER_NOT_LOGIN_USERSCOUNT,
      iconName: "person",
      sectionName: "Users didn't login yet",
      sectionDesc: "Users who didn't login yet on the app",
      selected: false,
    },
  ];

  var index = 0;

  if (action.type === DASHBOARD_ITEM_SELECTED) {
    for (var i = 0; i < state.length; i++) {
      if (state[i].key === action.payload.key) {
        index = i;
        break;
      }
    }
  }

  state[index].selected = true;
  return state;
};

export var DashboardSelectedItem = (state = DASHBOARD_USERS, action) => {
  if (action.type == DASHBOARD_ITEM_SELECTED) {
    state = action.payload.key;
  }
  return state;
};

// Local reducers for  Top search keywords {Most search keywords related to sessions}
export var DashboardMostsearchKeysTablelist = (state = {}, action) => {
  switch (action.type) {
    case DASHBOARD_MOSTSEARCH_KEYWORDS:
      return action.data;
    default:
      return state;
  }
};

// Local reducer for {Attendees Engagement (Chart view of how actively the exhibitor feature has been use over the selected date range)}

export const DashboardEngagementbarChart = (state = {}, action) => {
  switch (action.type) {
    case DASHBOARD_ENGAGEMENT_BARCHART:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};
